<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_2" title="Title Page">A Guidebook to Prayer</h2>
<p class="h3">Twenty-four ways to walk with God</p>
<p class="veryfirst"> </p>
<p class="h3"><span class="color">MaryKate Morse</span></p>
<p class="h3">Foreword by Joshua Choonmin Kang</p>
<p class="veryfirst"> </p>
<p class="firstcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books/books" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?283614f1